/* src/app/components/payroll/timesheets/timesheet-staff-deniedreasons/timesheet-staff-deniedreasons.component.css */
.custom-font-size {
  font-size: 14px !important;
}
/*# sourceMappingURL=timesheet-staff-deniedreasons.component-EHRF7IC4.css.map */
